import classnames from "classnames";
import PropTypes from "prop-types";
import ImagePill from "./ImagePill";
import HorizontalScrollList from "../../../../../../HorizontalScrollList";
import styles from "./VisualCategoryHeaderLinks.css";

const VisualCategoryHeaderLinks = ({ childLinks }) => {
  const classes = classnames(
    styles.sidePadding,
    styles.scrollBarMargin,
    styles.visualCategoryHeaderLinks
  );

  return (
    <HorizontalScrollList scrollSnapping={false} className={classes}>
      {childLinks.map(({ friendlyName, linkUrl, imageUrl }) => (
        <ImagePill
          key={friendlyName}
          friendlyName={friendlyName}
          linkUrl={linkUrl}
          imageUrl={imageUrl}
        />
      ))}
    </HorizontalScrollList>
  );
};

VisualCategoryHeaderLinks.propTypes = {
  childLinks: PropTypes.arrayOf(
    PropTypes.shape({
      friendlyName: PropTypes.string.isRequired,
      linkUrl: PropTypes.string.isRequired
    })
  )
};

export default VisualCategoryHeaderLinks;
